import { Fragment } from "react";

const inline = (text, key) => {
  const parts = text.split(/(\*\*[^*]+\*\*|`[^`]+`|\*[^*\s][^*]*\*|_[^_\s][^_]*_)/g);
  return parts.map((p, i) => {
    const k = `${key}-${i}`;
    if (/^\*\*[^*]+\*\*$/.test(p)) return <strong key={k}>{p.slice(2, -2)}</strong>;
    if (/^`[^`]+`$/.test(p)) return <code key={k}>{p.slice(1, -1)}</code>;
    if (/^(\*[^*]+\*|_[^_]+_)$/.test(p)) return <em key={k}>{p.slice(1, -1)}</em>;
    return <Fragment key={k}>{p}</Fragment>;
  });
};

const blocks = (md) => {
  const out = [];
  let cur = null;
  const flush = () => { if (cur) out.push(cur); cur = null; };
  for (const raw of md.replace(/\r/g, "").split("\n")) {
    const line = raw.trimEnd();
    const h = line.match(/^(#{2,4})\s+(.*)$/);
    const ul = line.match(/^\s*[-*]\s+(.*)$/);
    const ol = line.match(/^\s*\d+[.)]\s+(.*)$/);
    const q = line.match(/^>\s?(.*)$/);
    if (!line.trim()) { flush(); continue; }
    if (h) { flush(); out.push({ t: `h${Math.min(h[1].length, 3)}`, text: h[2] }); continue; }
    if (ul || ol) {
      const t = ul ? "ul" : "ol";
      if (!cur || cur.t !== t) { flush(); cur = { t, items: [] }; }
      cur.items.push((ul || ol)[1]);
      continue;
    }
    if (q) {
      if (!cur || cur.t !== "quote") { flush(); cur = { t: "quote", lines: [] }; }
      cur.lines.push(q[1]);
      continue;
    }
    if (cur && cur.t === "p") cur.lines.push(line);
    else if (cur && (cur.t === "ul" || cur.t === "ol") && /^\s{2,}/.test(raw)) cur.items[cur.items.length - 1] += ` ${line.trim()}`;
    else { flush(); cur = { t: "p", lines: [line] }; }
  }
  flush();
  return out;
};

export const Markdown = ({ source, testId }) => (
  <div className="pub-md" data-testid={testId}>
    {blocks(source || "").map((b, i) => {
      if (b.t === "h2") return <h2 key={i}>{inline(b.text, i)}</h2>;
      if (b.t === "h3") return <h3 key={i}>{inline(b.text, i)}</h3>;
      if (b.t === "ul") return <ul key={i}>{b.items.map((x, j) => <li key={j}>{inline(x, `${i}-${j}`)}</li>)}</ul>;
      if (b.t === "ol") return <ol key={i}>{b.items.map((x, j) => <li key={j}>{inline(x, `${i}-${j}`)}</li>)}</ol>;
      if (b.t === "quote") return <blockquote key={i}>{b.lines.map((x, j) => <p key={j}>{x ? inline(x, `${i}-${j}`) : "\u00a0"}</p>)}</blockquote>;
      return <p key={i}>{inline(b.lines.join(" "), i)}</p>;
    })}
  </div>
);
